import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../state";

export interface BackdropLoaderData {
  open: boolean;
  reload: boolean;
}

const initialState = {
  open: false,
  reload: false,
};

export const backdropLoaderSlice = createSlice({
  name: "backdropLoaderSlice",
  initialState,
  reducers: {
    setBackdropLoader: (state, action) => {
      return {
        open: action.payload.open,
        reload: action.payload.reload,
      };
    },
  },
});

export const selectBackdropLoader = (state: RootState): BackdropLoaderData =>
  state.backdropLoader;

export const { setBackdropLoader } = backdropLoaderSlice.actions;
export default backdropLoaderSlice.reducer;
